import { render, staticRenderFns } from "./RetinographyForm.vue?vue&type=template&id=700633b2"
import script from "./RetinographyForm.vue?vue&type=script&lang=js"
export * from "./RetinographyForm.vue?vue&type=script&lang=js"
import style0 from "./RetinographyForm.vue?vue&type=style&index=0&id=700633b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports